import React, { FC } from 'react';
import styled from 'styled-components';
import { CourseListingOnlineSection } from 'src/public/components/course-listing/CourseListingAllCoursesList/CourseListingOnlineSection';
import { CourseListingElearningSection } from 'src/public/components/course-listing/CourseListingAllCoursesList/CourseListingElearningSection';
import { CourseListingCourseBundlesSection } from 'src/public/components/course-listing/CourseListingAllCoursesList/CourseListingCourseBundlesSection';
import { Banner } from 'src/common/components/Banner';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

export const CourseListingAllCoursesList: FC = () => (
  <>
    <SectionContainer>
      <CourseListingOnlineSection />
    </SectionContainer>

    <Banner viewType={CourseViewType.All} />

    <SectionContainer>
      <CourseListingElearningSection />
    </SectionContainer>

    <SectionContainer>
      <CourseListingCourseBundlesSection />
    </SectionContainer>
  </>
);
